{
  "profile": {
    "details": "Detalles",
    "employment": "Empleo",
    "compliance": "Cumplimiento",
    "suitability": "Idoneidad",
    "idVerification": "Verificación de ID",
    "successMessages": {
      "details": "Se han actualizado los datos personales del cliente.",
      "employment": "Se han actualizado los datos laborales del cliente.",
      "compliance": "Se han actualizado los datos de conformidad del cliente.",
      "suitability": "Se han actualizado los datos de idoneidad del cliente.",
      "id": "Se han actualizado los datos de identificación del cliente."
    },
    "fieldValidations": {
      "noEmpty": "No puede estar vacío",
      "phone": "Número de teléfono, cuando corresponda, debe tener 10 dígitos.",
      "canadianNumberValidation": "El número de teléfono no tiene el formato válido de Canadá o EE. UU.",
      "primaryEmail": "El formato del correo electrónico debe ser el adecuado.",
      "number": "Debe ser un número",
      "sin": "El número de seguro social debe tener 9 dígitos.",
      "pleaseEnterValidTaxId": "Introduzca un número de identificación fiscal válido",
      "addressOutOfJurisdictionMessage": "Lo sentimos, pero la dirección ingresada se encuentra fuera de nuestra área de cobertura ({{ALLOWED_JURISDICTIONS}}).",
      "liquidAssetsRequired": "Se requieren activos líquidos"
    },
    "helpText": {
      "email": "Correo electrónico: Se utiliza para iniciar sesión",
      "phone": "Número de teléfono: Se utiliza para iniciar sesión"
    }
  },
  "authCredentialsUpdateConfirmation": {
    "email": {
      "title": "¿Está seguro de que desea actualizar el correo electrónico del cliente?",
      "subtitle": "¿Está seguro de que desea actualizar el correo electrónico del cliente? Se le pedirá que utilice este nuevo correo electrónico la próxima vez que inicie sesión en su cuenta."
    },
    "phone": {
      "title": "¿Está seguro de que desea actualizar el número de teléfono del cliente?",
      "subtitle": "¿Está seguro de que desea actualizar el número de teléfono del cliente? Deberá utilizar este nuevo número de teléfono la próxima vez que inicie sesión en su cuenta."
    },
    "emailAndPhone": {
      "title": "¿Está seguro de que desea actualizar el correo electrónico y el número de teléfono del cliente?",
      "subtitle": "¿Está seguro de que desea actualizar el correo electrónico y el número de teléfono del cliente? Se les pedirá que utilicen este nuevo correo electrónico y número de teléfono la próxima vez que inicien sesión en su cuenta."
    }
  },
  "confirmationDialog": {
    "title": "Está a punto de establecer el ID como ‘No verificado’",
    "subtitle": "Para cambiar esto, es posible que el cliente tenga que volver a verificar su ID antes de poder acceder a la aplicación para clientes.",
    "continueButton": "Continuar",
    "cancelButton": "Cancelar",
    "warning": "Este cliente no tiene un ID verificado"
  },
  "copied": "Copiado",
  "previousLabel": "Anterior {{label}}",
  "details": {
    "trustedContact": {
      "noEmpty": "No puede estar vacío",
      "emailFormatting": "El formato del correo electrónico debe ser el adecuado.",
      "phoneFormatting": "El formato del número de teléfono debe ser correcto.",
      "name": "Nombre",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "address": "Dirección",
      "relation": "Relación",
      "title": "Persona de contacto de confianza",
      "relationOptions": {
        "CHILD": "Menor",
        "FRIEND": "Amigo/a",
        "GRANDPARENT": "Abuelo/a",
        "OTHER": "Otro",
        "PARENT": "Padre/Madre",
        "SIBLING": "Hermano/a",
        "SPOUSE": "Esposo/a"
      },
      "notAvailableMeta": {
        "header": "No hay ninguna persona de contacto de confianza disponible",
        "body": "Aquí puede agregar la información de una persona de contacto de confianza"
      }
    },
    "needsToBeFilled": "Necesita ser llenado",
    "placeholders": {
      "issueSource": "Escriba aquí el origen del problema",
      "companySymbol": "Escriba aquí el símbolo de la empresa",
      "registrationNumber": "Escriba aquí el número de registro",
      "selectAnOption": "Seleccione una opción",
      "selectRiskLevel": "Seleccione un nuevo nivel de riesgo para el cliente",
      "note": "Escriba una nota sobre el cambio"
    },
    "errorMessages": {
      "notSelected": "No seleccionado",
      "profileIncomplete": "<b>¡Acción requerida!</b> Es necesario completar los campos de esta sección",
      "fieldsToBeFilled": "<b>¡Acción requerida!</b> Hay algunos campos que deben completarse."
    },
    "profileStatusBox": {
      "header": "Estado del perfil",
      "annualCheckStatusTitle": "Estado de verificación del informe anual",
      "clientAgreementsAreReadyToSignTitle": "Los acuerdos con el cliente están listos para firmar",
      "approved": "Aprobado",
      "overdue": "Vencido",
      "lastCheckDate": "Fecha de actualización de la información",
      "notAvailableMeta": {
        "header": "No hay estado del perfil disponible",
        "body": "Debe agregar la información necesaria para mostrar el estado del cliente."
      }
    },
    "spouseInformationBox": {
      "header": "Información del cónyuge",
      "spouseFirstName": "Nombre",
      "spouseMiddleName": "Segundo nombre",
      "spouseLastName": "Apellido",
      "spouseJobTitle": "Puesto",
      "spouseCompanyType": "Tipo de empresa",
      "spouseEmployerName": "Nombre del empleador",
      "spouseEmploymentType": "Tipo de empleo",
      "spouseAddress": "Dirección",
      "spouseEmail": "Correo electrónico",
      "requiredMeta": {
        "header": "Información requerida",
        "buttonText": "AGREGAR DATOS"
      }
    },
    "employmentBox": {
      "header": "Empleo",
      "requiredMeta": {
        "header": "Información requerida",
        "buttonText": "AGREGAR DATOS"
      },
      "employmentStatusTitle": "Situación laboral",
      "jobTitle": "Puesto",
      "companyTypeTitle": "Tipo de empresa",
      "studentAreaOfStudy": "Área de estudio",
      "employerNameTitle": "Nombre de la empresa",
      "employerCompanyAddressTitle": "Dirección de la empresa",
      "employmentSituationTitle": "Situación laboral",
      "employmentSituationOtherDescriptionTitle": "Descripción de la situación laboral",
      "previous": {
        "jobTitle": "Título del empleo anterior",
        "companyTypeTitle": "Tipo de empresa anterior",
        "employerNameTitle": "Nombre de la empresa anterior",
        "employerCompanyAddressTitle": "Dirección de la empresa anterior"
      },
      "taxIdTypeTitle": "Tipo de ID fiscal"
    },
    "entityInformation": {
      "header": "Información de la entidad",
      "countryOfRegistration": "País de registro",
      "registrationNumber": "Número de registro"
    },
    "riskLevelBox": {
      "header": "Puntuación de riesgo de delitos financieros: {{riskLevel}}",
      "riskLevel": {
        "0": "País o ocupación de alto riesgo",
        "1": "Bajo",
        "2": "Medio",
        "3": "Alto"
      },
      "notAvailableMeta": {
        "header": "No se puede generar el nivel de riesgo",
        "body": "Debe completar el perfil del cliente para calcular el nivel de riesgo"
      },
      "reason": "Razón",
      "previousChangeQuestion": "¿Algún cambio manual previo en el nivel de riesgo?",
      "overrideExistingLevel": "¿Anular el nivel de riesgo del cliente existente?",
      "newFraudRiskScore": "Nueva puntuación de riesgo de fraude",
      "notes": "Notas"
    },
    "idVerificationBox": {
      "header": "Verificación de ID",
      "addIDVerification": "Agregar: verificación de ID",
      "updateIDVerification": "Actualizar: verificación de ID",
      "modalBoxPredix": "Crear",
      "idVerifiedLabel": "ID verificada",
      "idNotVerifiedLabel": "ID no verificada",
      "requiredMeta": {
        "header": "Se requiere información de ID",
        "buttonText": "AGREGAR DATOS"
      },
      "typeTitle": "TIPO",
      "jurisdictionTitle": "JURISDICCIÓN",
      "expiryDate": "FECHA DE VENCIMIENTO",
      "methodOfIdVerification": "MÉTODO DE VERIFICACIÓN DE ID"
    },
    "clientFeesBox": {
      "header": "Tarifas para clientes",
      "requiredMeta": {
        "header": "Información requerida",
        "buttonText": "TARIFAS ESTABLECIDAS"
      },
      "feeGridTitle": "Tabla de tarifas",
      "billingCycleTitle": "Ciclo de facturación",
      "organizationDefault": "Organización predeterminada"
    },
    "suitabilityBox": {
      "suitabilityScoreNotAvailableLabel": "Puntuación de idoneidad: no disponible",
      "suitabilityScoreLabel": "Puntuación de idoneidad: {{suitabilityScore}}",
      "requiredMeta": {
        "header": "La puntuación de idoneidad se generará después de que se haya añadido la información.",
        "buttonText": "AGREGAR DATOS"
      },
      "annualIncomeTitle": "Ingresos anuales",
      "annualIncomeRangeTitle": "Intervalo de ingresos anuales",
      "totalLiquidAssetsTitle": "Total de activos líquidos",
      "totalFixedAssetsTitle": "Total de activos fijos",
      "totalDebtTitle": "Deuda total",
      "annualDebtPaymentsTitle": "Pagos anuales de deuda",
      "isAccreditedInvestorTitle": "Inversor acreditado",
      "investmentKnowledgeTitle": "Conocimientos sobre inversiones",
      "riskQuestion1Title": "Pregunta sobre riesgos 1",
      "riskQuestion2Title": "Pregunta sobre riesgos 2",
      "sourceOfWealthTitle": "Origen de la riqueza",
      "sourceOfFundsTitle": "Origen de los fondos",
      "uniqueCircumstancesTitle": "Circunstancias únicas",
      "none": "Ninguno",
      "sourceOfWealthOtherDescriptionTitle": "Descripción del origen de la riqueza",
      "sourceOfFundsOtherDescriptionTitle": "Descripción del origen de los fondos"
    },
    "citizenshipAndTaxStatusInformationBox": {
      "individualHeader": "Estado civil, ciudadanía y situación fiscal",
      "nonIndividualHeader": "Situación fiscal",
      "maritalStatusTitle": "Estado civil",
      "numberOfDependents": "Número de personas a su cargo",
      "citizenshipsTitle": "Ciudadanías",
      "countryOfTaxResidenceTitle": "País de residencia fiscal",
      "foreignTaxInformationTitle": "Información sobre impuestos extranjeros",
      "countryTitle": "PAÍS",
      "taxIdentificationNumberTitle": "NÚMERO DE IDENTIFICACIÓN FISCAL",
      "taxNumber": "Impuesto №",
      "yearEnd": "Fecha de cierre del ejercicio"
    },
    "personAndEntitiesOfInterestBox": {
      "header": "Personas y entidades de interés",
      "officerOfAPublicCompanyTitle": "Funcionario de una empresa pública",
      "ownerOfPublicCompanyTitle": "Propietario de una empresa pública",
      "publicCompanySymbol": "Símbolo de empresa pública",
      "memberOfIIROCTitle": "Miembro de IIROC",
      "IIROCCompanySymbolTitle": "Símbolo de la empresa IIROC",
      "politicallyExposedDomesticPersonTitle": "Persona políticamente expuesta a nivel nacional",
      "politicallyExposedForeignPersonTitle": "Persona extranjera políticamente expuesta",
      "closeAssociateOfPEPTitle": "Asociado cercano de PEP",
      "powerOfAttorneyGrantedTitle": "Poder notarial otorgado",
      "complianceStateTitle": "Estado de cumplimiento",
      "headOfInternationalOrganizationTitle": "Jefe de Organización Internacional",
      "complianceIssueSourceTitle": "Origen del problema de cumplimiento",
      "diminishedCapacityTitle": "Capacidad disminuida",
      "isVulnerablePerson": "Persona vulnerable",
      "isOwnerOfEntity": "Propietario de la entidad"
    },
    "entityOfInterestBox": {
      "header": "Entidad de interés",
      "isNonProfitTitle": "Sin fines de lucro",
      "receivesDonationsFromPublic": "Solicita donaciones al público",
      "isRegisteredWithCRATitle": "Registrado ante la CRA",
      "charityRegistrationNumber": "Registro de organización benéfica n. º",
      "isEntityRegulatedTitle": "Regulado",
      "regulatorNameTitle": "Nombre del regulador",
      "regulatorRegistrationNumber": "Registro del regulador n. º",
      "isReportingIssuerTitle": "Emisor del informe",
      "issuerNameTitle": "Nombre del emisor",
      "issuerTickerTitle": "Símbolo del emisor",
      "issuerExchangeTitle": "Emisor de intercambio",
      "isAFinancialEntityTitle": "Una entidad financiera o empresa relacionada",
      "isAffiliateOfFinancialEntityTitle": "Una filial de una entidad financiera",
      "instructionsFromFinancialEntityTitle": "Instrucciones autorizadas por una entidad financiera",
      "isPublicBodyTitle": "Organismo público",
      "isForThirdPartyTitle": "Para terceros",
      "isLargeCorporation": "Empresa muy grande"
    },
    "relationOptions": {
      "CHILD": "Menor",
      "FRIEND": "Amigo/a",
      "GRANDPARENT": "Abuelo/a",
      "OTHER": "Otro",
      "PARENT": "Padre/Madre",
      "SIBLING": "Hermano/a",
      "SPOUSE": "Esposo/a",
      "COMMON_LAW": "Derecho consuetudinario",
      "GRANDCHILD": "Nieto/a",
      "GUARDIAN": "Tutor/a",
      "NEPHEW_NIECE": "Sobrino/Sobrina",
      "PRIMARY_CAREGIVER": "Cuidador principal"
    },
    "editClientDetail": "Editar datos del cliente",
    "editNonIndivEntityDetail": "Actualizar entidad no individual",
    "riskLevel": "Nivel de riesgo",
    "idVerification": "Verificación de ID",
    "firstName": "Nombre",
    "middleName": "Segundo nombre",
    "lastName": "Apellido",
    "allocation": "Asignación",
    "entityName": "Nombre de la entidad",
    "clientName": "Nombre del cliente",
    "primaryEmail": "Correo electrónico",
    "phone": "Teléfono",
    "country": "País",
    "province": "Provincia",
    "city": "Ciudad",
    "preferredLanguages": "Idioma preferido",
    "dateOfBirth": "Fecha de nacimiento",
    "dateOfDeath": "Fecha de deceso",
    "establishedDate": "Establecido",
    "numClientsInEntity_one": "1 cliente en esta entidad",
    "numClientsInEntity_other": "{{count}} clientes de esta entidad",
    "inProvinceSince": "En la provincia desde",
    "physicalAddress": "Dirección",
    "gender": "Género",
    "state": {
      "FROZEN": "Congelado",
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo"
    },
    "stateTooltip": {
      "FROZEN": "El cliente congelado no puede iniciar ninguna transferencia. Haga clic en el menú de puntos suspensivos situado a la derecha para cambiar el estado del cliente a activo.",
      "INACTIVE": "Este cliente ha sido desactivado de forma permanente."
    },
    "idVerificationNotCompletedTooltip": "Agregue una verificación de ID dentro de la pestaña de detalles.",
    "complianceStateNotApprovedTooltip": "Vaya a la pestaña Detalles para aprobar los datos de cumplimiento del cliente.",
    "incompleteProfileTooltip": "Vaya a la pestaña de Detalles y actualice la información incompleta",
    "allDocumentSigned": "Todos los documentos firmados",
    "unsignedDocuments_one": "1 documento sin firmar",
    "unsignedDocuments_other": "{{count}} documentos sin firmar",
    "unsignedDocumentsTooltip": "Firme los documentos accediendo a la pestaña de documentos.",
    "annualInfoUpToDate": "Información anual actualizada",
    "annualInfoNeedsReview": "Actualización de la información anual",
    "suitabilityReviewOverdue": "La última revisión de idoneidad se realizó hace {{months}} meses.",
    "complianceStateNeedsReview": "Es necesario revisar el estado del cumplimiento",
    "annualInfoNeedsReviewTooltip": "La última revisión de idoneidad se realizó hace {{months}} meses. Actualice la información del cliente seleccionando el botón Editar en el estado del perfil, dentro de la pestaña Detalles.",
    "freeze": "Congelar",
    "activate": "Activar",
    "deactivate": "Desactivar",
    "deactivationConfirmation": {
      "title": "¿Desea desactivar {{clientName}}?",
      "body": "Esta acción no se puede deshacer."
    },
    "transitionUser": "Seleccionar transición",
    "maritalStatus": "Estado civil",
    "clientsStatus": "Historial del estatus del cliente",
    "viewClientStatus": "Ver historial de estatus del cliente",
    "employmentStatus": "Situación laboral",
    "jobTitle": "Puesto",
    "companyType": "Tipo de empresa",
    "employerName": "Nombre de la empresa",
    "employerCompanyAddress": "Dirección de la empresa",
    "employmentSituation": "Situación laboral",
    "relation": "Relación",
    "studentAreaOfStudy": "Área de estudio",
    "sin": "SIN",
    "isOfficerOfPublicCompany": "Funcionario de empresa pública",
    "isOwnerOfPublicCompany": "Propietario de una empresa pública",
    "isMemberOfIiroc": "Miembro de IIROC",
    "politicallyExposedForeignPerson": "Persona extranjera políticamente expuesta",
    "politicallyExposedDomesticPerson": "Persona políticamente expuesta a nivel nacional",
    "closeAssociateOfPEP": "Asociado cercano de PEP",
    "powerOfAttorneyGranted": "Poder notarial otorgado",
    "headOfInternationalOrganization": "Jefe de Organización Internacional",
    "ssSymbols": "Símbolo de empresa pública",
    "insiderSymbols": "Símbolo de la empresa IIROC",
    "sinPlaceholder": "No se mostrará, solo se actualizará",
    "complianceState": "Estado de cumplimiento",
    "complianceIssueSource": "Origen del problema de cumplimiento",
    "annualIncomeCents": "Ingresos anuales",
    "financialLiquidAssetsCents": "Total de activos líquidos",
    "financialFixedAssetsCents": "Total de activos fijos",
    "totalDebtCents": "Deuda total",
    "annualDebtPaymentsCents": "Pagos anuales de deuda",
    "investmentKnowledge": "Conocimientos sobre inversiones",
    "updateGoal": "Actualizar objetivo",
    "addID": "Agregar: verificación de ID",
    "updateID": "Actualizar: verificación de ID",
    "riskQuestion1": "Pregunta sobre riesgos 1",
    "riskQuestion1Answer": {
      "LEVEL_5": "Maximizar las ganancias",
      "LEVEL_3": "Ambos por igual",
      "LEVEL_1": "Minimizar las pérdidas"
    },
    "riskQuestion2": "Pregunta sobre riesgos 2",
    "riskQuestion2Answer": {
      "LEVEL_4": "No haga nada",
      "LEVEL_3": "Retire algo de dinero",
      "LEVEL_2": "Retire algo de dinero",
      "LEVEL_1": "Retirar todo el dinero",
      "LEVEL_5": "Invertir más"
    },
    "annualInfoNeedsReviewNotice": "Actualización de la información anual — La última revisión de idoneidad se realizó hace {{months}} meses."
  },
  "editClientOrganization": {
    "moveClientToAnotherOrganization": "Mueva al cliente a otra organización",
    "currentOrganization": "Organización actual",
    "cannotMoveHouseholdMembers": "Los clientes que sean miembros de un hogar o una corporación no pueden ser cambiados.",
    "confirmationTitle": "¿Está seguro de que desea actualizar la organización del cliente?",
    "confirmationSubtitle": "Se les asignará a una nueva organización, lo que puede afectar a la presentación de informes, el inicio de sesión, las carteras u otras configuraciones.",
    "updatedToastMessage": "El cliente {{clientName}} ha sido trasladado a una nueva organización.",
    "selectOrganization": "Seleccione una organización"
  },
  "menu": {
    "editProfile": "Editar perfil",
    "moveToAnotherOrganization": "Cambiar a otra organización",
    "copyProfileURL": "Copiar la URL del perfil",
    "freezeClient": "Congelar cliente",
    "copyID": "Copiar ID",
    "addToHousehold": "Agregar a un hogar"
  },
  "form": {
    "update": "Actualizar",
    "edit": "Editar",
    "add": "Añadir"
  },
  "edit": {
    "goal": {
      "updatedToastMessage": "La meta se ha actualizado.",
      "applyPortfolioAtGoal": "Aplicar cartera a la meta",
      "noPermissions": "No tiene permiso para editar una meta"
    },
    "buttons": {
      "save": "Guardar"
    },
    "complianceStateOptions": {
      "APPROVED": "Aprobado",
      "NEEDS_REVIEW": "Necesita revisión",
      "REJECTED": "Rechazado"
    },
    "debtAssociatedOptions": {
      "MORTGAGE": "Hipoteca",
      "CREDIT_CARD": "Tarjeta de crédito",
      "STUDENT_LOAN": "Préstamo estudiantil"
    },
    "employmentStatusOptions": {
      "EMPLOYED": "Empleado/a",
      "SELF_EMPLOYED": "Trabajador/a independiente",
      "RETIRED": "Jubilado/a",
      "UNEMPLOYED": "Sin empleo",
      "STUDENT": "Estudiante",
      "STAY_AT_HOME_PARENT": "Ama de casa"
    },
    "fatcaStatus": "Estado FATCA",
    "fatcaStatusOptions": {
      "PUBLICLY_TRADED_NFFE": "NFFE que cotiza en bolsa",
      "INTERNATIONAL_ORGANIZATION": "Organización internacional",
      "GOVERNMENT": "Gobierno",
      "CENTRAL_BANK": "Banco central",
      "ACTIVE_NFFE": "NFFE activa",
      "PASSIVE_NFFE": "NFFE pasivo",
      "OTHER": "Otros"
    },
    "fatcaStatusOtherDescription": "Otra descripción del estado FATCA",
    "employmentSituationOptions": {
      "STABLE_AND_SECURE": "Estable y seguro",
      "STABLE_BUT_MAY_CHANGE_IN_FUTURE": "Estable, pero puede cambiar en el futuro",
      "SOMEWHAT_STABLE": "Algo estable",
      "UNEMPLOYED_BUT_LOOKING": "Sin empleo, pero en busca de trabajo",
      "OTHER": "Otro"
    },
    "relationOptions": {
      "CHILD": "Menor",
      "FRIEND": "Amigo/a",
      "GRANDPARENT": "Abuelo/a",
      "OTHER": "Otros",
      "PARENT": "Padre/Madre",
      "SIBLING": "Hermano/a",
      "SPOUSE": "Esposo/a"
    },
    "scoreOptions": {
      "0": "País o ocupación de alto riesgo",
      "1": "Bajo",
      "2": "Medio",
      "3": "Alto"
    },
    "languageOptions": {
      "FRENCH": "Francés",
      "ENGLISH": "Inglés"
    },
    "preferredMethodOfCommunicationOptions": {
      "EMAIL": "Correo electrónico",
      "PHONE": "Teléfono",
      "TEXT": "Texto",
      "OTHER": "Otro"
    },
    "maritalStatusOptions": {
      "SINGLE": "Soltero/a",
      "MARRIED": "Casado/a",
      "COMMON_LAW": "Derecho consuetudinario",
      "DIVORCED": "Divorciado/a",
      "SEPARATED": "Separado/a",
      "WIDOWED": "Viudo/a",
      "CIVIL_UNION": "Unión civil"
    },
    "documentIssuingJurisdicationOptions": {
      "ALBERTA": "Alberta",
      "BRITISH_COLUMBIA": "Columbia Británica",
      "MANITOBA": "Manitoba",
      "NEW_BRUNSWICK": "Nuevo Brunswick",
      "NEW_FOUNDLAND_AND_LABRADOR": "Terranova y Labrador",
      "NOVA_SCOTIA": "Nueva Escocia",
      "ONTARIO": "Ontario",
      "PRINCE_EDWARD_ISLAND": "Isla del Príncipe Eduardo",
      "SASKATCHEWAN": "Saskatchewan",
      "QUEBEC": "Quebec",
      "YUKON": "Yukon",
      "NORTH_WEST_TERRITORIES": "Territorios del Noroeste",
      "NUNAVUT": "Nunavut",
      "FEDERAL": "Federal",
      "OTHER": "Otro"
    },
    "jurisdicationOptionsForUsandCanada": {
      "ALBERTA": "Alberta",
      "BRITISH_COLUMBIA": "Columbia Británica",
      "MANITOBA": "Manitoba",
      "NEW_BRUNSWICK": "Nuevo Brunswick",
      "NEW_FOUNDLAND_AND_LABRADOR": "Terranova y Labrador",
      "NOVA_SCOTIA": "Nueva Escocia",
      "ONTARIO": "Ontario",
      "PRINCE_EDWARD_ISLAND": "Isla del Príncipe Eduardo",
      "SASKATCHEWAN": "Saskatchewan",
      "QUEBEC": "Quebec",
      "YUKON": "Yukon",
      "NORTH_WEST_TERRITORIES": "Territorios del Noroeste",
      "NUNAVUT": "Nunavut",
      "FEDERAL": "Federal",
      "ALASKA": "Alaska",
      "ALABAMA": "Alabama",
      "ARIZONA": "Arizona",
      "ARKANSAS": "Arkansas",
      "CALIFORNIA": "California",
      "COLORADO": "Colorado",
      "CONNECTICUT": "Connecticut",
      "DELAWARE": "Delaware",
      "DISTRICT_OF_COLUMBIA": "Distrito de Columbia",
      "FLORIDA": "Florida",
      "GEORGIA": "Georgia",
      "GUAM": "Guam",
      "HAWAII": "Hawái",
      "IDAHO": "Idaho",
      "ILLINOIS": "Illinois",
      "INDIANA": "Indiana",
      "IOWA": "Iowa",
      "KANSAS": "Kansas",
      "KENTUCKY": "Kentucky",
      "LOUISIANA": "Louisiana",
      "MAINE": "Maine",
      "MARSHALL_ISLAND": "Islas Marshall",
      "MICHIGAN": "Michigan",
      "MARYLAND": "Maryland",
      "MASSACHUSETTS": "Massachusetts",
      "MINNESOTA": "Minnesota",
      "MISSISSIPPI": "Mississippi",
      "MISSOURI": "Missouri",
      "MONTANA": "Montana",
      "NEBTASKA": "Nebraska",
      "NEVADA": "Nevada",
      "NEW_HAMPSHIRE": "Nuevo Hampshire",
      "NEW_JERSEY": "Nueva Jersey",
      "NEW_MEXICO": "Nuevo México",
      "NEW_YORK": "Nueva York",
      "NORTH_CAROLINA": "Carolina del Norte",
      "NORTH_DAKOTA": "Dakota del Norte",
      "OHIO": "Ohio",
      "OKLAHOMA": "Oklahoma",
      "OREGON": "Oregon",
      "PALAU": "Palaos",
      "PENNSYLVANIA": "Pensilvania",
      "PUERTO_RICO": "Puerto Rico",
      "RHODE_ISLAND": "Isla de Rhode",
      "SOUTH_CAROLINA": "Carolina del Sur",
      "SOUTH_DAKOTA": "Dakota del Sur",
      "TENNESSEE": "Tennessee",
      "TEXAS": "Texas",
      "UTAH": "Utah",
      "US_VIRGIN_ISLAND": "Islas Vírgenes",
      "VERMONT": "Vermont",
      "VIGINIA": "Virginia",
      "WASHINGTON": "Washington",
      "WEST_VIRGINIA": "Virginia Occidental",
      "WINSCONSIN": "Wisconsin",
      "WYOMING": "Wyoming",
      "US": "Estados Unidos",
      "CA": "Canadá",
      "OTHER": "Otros"
    },
    "noJurisdication": "N/A",
    "noJDocumentType": "N/A",
    "noExpiryDate": "N/A",
    "methodOfIDVerificationOptions": {
      "CREDIT_CHECK": "Revisión de crédito",
      "DIGITAL_DOCUMENT_CHECK": "Revisión de documentos digitales",
      "DUAL_METHOD": "Método de doble proceso",
      "IN_PERSON_VALIDATION": "Revisión física de la tarjeta ID",
      "CONFIRMATION_OF_EXISTENCE": "Confirmación de existencia"
    },
    "investmentKnowledgeOptions": {
      "NONE": "Ninguno",
      "LIMITED": "Limitado",
      "SOME": "Algunos",
      "EXPERT": "Experto"
    },
    "riskQuestion1Options": {
      "LEVEL_1": "Nivel 1",
      "LEVEL_2": "Nivel 2",
      "LEVEL_3": "Nivel 3",
      "LEVEL_4": "Nivel 4",
      "LEVEL_5": "Nivel 5"
    },
    "riskQuestion2Options": {
      "LEVEL_1": "Nivel 1",
      "LEVEL_2": "Nivel 2",
      "LEVEL_3": "Nivel 3",
      "LEVEL_4": "Nivel 4",
      "LEVEL_5": "Nivel 5"
    },
    "sourceOfWealthOptions": {
      "EMPLOYMENT_INCOME": "Ingresos por empleo",
      "SALE_OF_LARGE_ASSET": "Venta de activos de gran valor",
      "PROPERTY_SALE": "Venta de propiedades",
      "INHERITANCE": "Herencia",
      "FAMILY_ESTATE": "Propiedad familiar",
      "INVESTMENT": "Inversión",
      "BUSINESS_OWNERSHIP_INTEREST": "Participación en la propiedad de la empresa",
      "DEBT": "Deuda",
      "LOTTERY_WINNING": "Ganar la lotería",
      "OTHER": "Otro"
    },
    "sourceOfFundsOptions": {
      "CONTRIBUTIONS": "Contribuciones",
      "DEBT": "Deuda",
      "DONATIONS": "Donaciones",
      "EMPLOYMENT_INCOME": "Ingresos por empleo",
      "INCOME_OR_WORKING_CAPITAL": "Ingresos del fondo de operatividad",
      "INHERITANCES_AND_GIFT": "Herencias y regalos",
      "LOTTERY_WINNING": "Ganar la lotería",
      "OTHER": "Otro",
      "PENSION_RELEASE": "Liberación de pensión",
      "PERSONAL_SAVINGS": "Ahorros personales",
      "PROCEEDS_FROM_INVESTMENTS": "Ingresos por inversiones",
      "PROPERTY_SALE": "Venta de propiedades",
      "SALE_OF_LARGE_ASSET": "Venta de activos de gran valor",
      "SHARES_SALES_AND_DIVIDENDS": "Venta de acciones y dividendos"
    },
    "typeOfTrustOptions": {
      "COMPLEX": "Fideicomiso complejo",
      "SIMPLE": "Fideicomiso simple",
      "GRANTOR": "Fideicomiso otorgante"
    }
  },
  "tabs": {
    "overview": "Resumen general",
    "details": "Detalles",
    "relationships": "Relaciones",
    "goals": "Metas",
    "accounts": "Cuentas",
    "agreements": "Acuerdos",
    "documents": "Documentos",
    "bankAccounts": "Cuentas bancarias",
    "activity": "Actividad",
    "performance": "Rendimiento",
    "profile": "Perfil",
    "transfers": "Transferencias",
    "trades": "Transacciones",
    "ledger": "Libro mayor",
    "statements": "Declaraciones",
    "notes": "Notas",
    "audit_log": "Registro de auditoría",
    "organization_user_entities": "Acceso"
  },
  "audit": {
    "changedBy": "Modificado por",
    "type": "Tipo",
    "changedObject": "Objeto modificado",
    "changedFields": "Campos modificados",
    "timestamp": "Sello de fecha y hora",
    "from": "Desde",
    "to": "A",
    "field": "Campo",
    "detailDate": "Fecha",
    "detailTraceId": "Trace",
    "detailObjectIdLabel": "ID de {{changedObject}}",
    "detailObjectIdLabelFallback": "id",
    "detailChangedByEmail": "Modificado por",
    "errorLoading": "No se pudo cargar el registro de auditoría",
    "productName": "Nombre del producto",
    "ticker": "Símbolo bursátil",
    "noClientFound": "No se encontró ningún cliente",
    "searchFailed": "No se pudo buscar al cliente. Inténtelo de nuevo.",
    "toolbar": {
      "clientSearch": "Búsqueda de cliente",
      "apply": "Aplicar",
      "filters": {
        "date": "Selector de fecha",
        "changedBy": "Modificado por",
        "clientName": "Nombre del cliente",
        "type": "Tipo",
        "changedObject": "Objeto modificado"
      }
    },
    "clientName": "Nombre del cliente",
    "filters": {
      "clientName": "Nombre del cliente",
      "clientNameSearch": "Buscar clientes",
      "noClientNameOptions": "No hay clientes en los resultados cargados",
      "maxClientNamesSelected": "Se pueden seleccionar un máximo de {{max}} clientes",
      "type": "Tipo",
      "maxTypesSelected": "Se pueden seleccionar un máximo de {{max}} tipos",
      "date": "Fecha",
      "dateFrom": "Desde",
      "dateTo": "Hasta",
      "invalidDateRange": "La fecha de finalización debe ser igual o posterior a la fecha de inicio",
      "changedBy": "Modificado por",
      "changedBySearch": "Buscar por modificado por",
      "noChangedByOptions": "No hay opciones de 'modificado por' en los resultados cargados",
      "changedObject": "Objeto modificado",
      "changedObjectSearch": "Buscar objeto modificado",
      "noChangedObjectOptions": "No hay opciones de 'objeto modificado' en los resultados cargados",
      "maxChangedBySelected": "Se pueden seleccionar un máximo de {{max}} actores de 'modificado por'",
      "maxChangedObjectsSelected": "Se pueden seleccionar un máximo de {{max}} objetos modificados"
    }
  },
  "userChangesOnly": "Cambios de usuario únicamente",
  "moreFields": "más campos",
  "completed": "Perfil completado",
  "notCompleted": "Perfil sin completar",
  "idVerified": "verificado",
  "idNotVerified": "no verificado",
  "suitabilityScore": "Puntuación de idoneidad",
  "theme": "Tema",
  "idTable": {
    "documentId": "ID",
    "documentType": "Tipo",
    "methodOfIDVerification": "Método",
    "documentIssuingJurisdication": "Jurisdicción",
    "documentExpiryDate": "Fecha de vencimiento",
    "verifiedDate": "Verificado"
  },
  "none": "Ninguno",
  "cash": "Efectivo",
  "accountNumber": "Número de cuenta",
  "accountName": "Nombre de la cuenta",
  "subAccountState": {
    "AWAITING_APPROVAL": "En espera de aprobación",
    "ACTIVE": "Activo",
    "INACTIVE": "Inactivo",
    "PENDING": "Pendiente",
    "CLOSED": "Cerrado"
  },
  "marketValue": "Total de activos",
  "account": "Cuenta",
  "subAccount": "Subcuenta",
  "accountGroup": "Grupo de cuentas",
  "client": "Cliente",
  "entity": "Entidad",
  "clientGroup": "Grupo de clientes",
  "goal": "Meta",
  "groupBy": "Agrupar por",
  "security": "Seguridad",
  "primaryAssetClass": "Clase de activos primarios",
  "secondaryAssetClass": "Clase de activos secundarios",
  "tertiaryAssetClass": "Clase de activos terciarios",
  "ofTotal": "del total",
  "na": "N/A",
  "goalTypes": "Tipo de meta",
  "goalName": "Nombre de meta",
  "goalType": {
    "CAR": "Coche",
    "BUILD_WEALTH": "Generar riqueza",
    "RETIREMENT": "Jubilación",
    "MAJOR_PURCHASE": "Compra importante",
    "HOUSE": "Casa",
    "EDUCATION": "Educación",
    "VACATION": "Vacaciones",
    "START_A_BUSINESS": "Iniciar un negocio",
    "WEDDING": "Boda",
    "PARENTAL_LEAVE": "Licencia parental",
    "SAFETY_NET": "Red de seguridad",
    "OTHER": "Otros",
    "CASH_RESERVE": "Reserva de efectivo",
    "LEGACY": "Herencia",
    "GROUP": "Grupo",
    "RETIREMENT_INCOME": "Ingresos para la jubilación"
  },
  "accountType": "Tipo de cuenta",
  "selectGoal": "Seleccionar objetivo",
  "editName": "Nombre",
  "newIDVerification": "Nuevo ID verificación",
  "methodOfIDVerification": "Método de verificación de ID",
  "firstDocument": "Firmar documento",
  "secondDocument": "Segundo documento",
  "noIds": "No hay ID de documentos de verificación",
  "idVerificationMethods": {
    "CREDIT_CHECK": "Revisión de crédito",
    "DIGITAL_DOCUMENT_CHECK": "Revisión de documentos digitales",
    "DUAL_METHOD": "Método dual",
    "IN_PERSON_VALIDATION": "Validación presencial"
  },
  "documentType": "Tipo de documento",
  "documentTypesLabels": {
    "creditCheckDocumentTypes": "Seleccione los documentos que desea adjuntar",
    "digitalDocumentTypes": "Seleccione los documentos de verificación digital que desea adjuntar",
    "dualVerificationTypes": "Seleccione los documentos de verificación dual que desea presentar como respaldo",
    "inPersonVerificationTypes": "Seleccione los documentos para la verificación presencial que desea presentar como respaldo"
  },
  "documentTypes": {
    "BANK_STATEMENT": "Estado de cuenta bancaria",
    "BENEFITS_STATEMENT": "Declaración de beneficios",
    "BIRTH_CERTIFICATE": "Certificado de nacimiento",
    "CREDIT_BUREAU": "Oficina de crédito",
    "CAD_CREDIT_BUREAU_PRODUCT": "Oficina de crédito",
    "CANADA_411": "Canadá 411",
    "CITIZENSHIP_CARD": "Tarjeta de ciudadanía",
    "CITIZENSHIP_CERTIFICATE": "Certificado de ciudadanía",
    "CONFIRMATION_FROM_FINANCIAL_ENTITY": "Confirmación de la entidad financiera",
    "CREDIT_CARD_STATEMENT": "Estado de cuenta de tarjeta de crédito",
    "CREDIT_FILE": "Expediente de crédito",
    "DIVORCE_DOCUMENTATION": "Documentación del divorcio",
    "DRIVERS_LICENSE": "Licencia de conducir",
    "GLOBAL_ENTRY_CARD": "Tarjeta Global Entry",
    "GOV_ISSUED_CPP_STATEMENT": "Declaración del CPP emitida por el Gobierno",
    "GOV_ISSUED_VEHICLE_REGISTRATION": "Registro de vehículos emitido por el gobierno",
    "HEALTH_CARD": "Tarjeta de salud",
    "ID": "ID",
    "INDIAN_STATUS_CARD": "Tarjeta de estatus indígena",
    "INSURANCE_DOCUMENT": "Documento del seguro",
    "INVESTMENT_ACCOUNT_STATEMENT": "Estado de cuenta de inversión",
    "LOAN_ACCOUNT_STATEMENT": "Estado de cuenta de préstamo",
    "MARRIAGE_LICENCE": "Licencia de matrimonio",
    "MICRO_DEPOSIT": "Microdepósito",
    "MILITARY_ID": "ID militar",
    "NEXUS": "Nexus",
    "OTHER": "Otro",
    "PASSPORT": "Pasaporte",
    "PERMANENT_RESIDENT_CARD": "Tarjeta de residencia permanente",
    "PROCESSED_CHEQUE": "Cheque procesado",
    "PROPERTY_TAX_ASSESSMENT": "Tasación del impuesto sobre la propiedad",
    "PROVINCIAL_ID": "ID Provincial",
    "RECORD_OF_EMPLOYMENT": "Registro de empleo",
    "SCHOOL_DOCUMENT": "Documento escolar",
    "SOCIAL_SECURITY_CARD": "Tarjeta del Seguro Social",
    "STATE_ID": "ID del estado",
    "TRAVEL_VISA": "Visa de viaje",
    "UTILITY_STATEMENT": "Declaración de utilidad"
  },
  "secondaryDocumentType": "Tipo de documento secundario",
  "secondaryDocumentIssuingJurisdication": "Jurisdicción de emisión de documentos secundarios",
  "secondaryDocumentExpiryDate": "Fecha de vencimiento del documento secundario",
  "secondaryDocumentID": "ID de documento secundario",
  "secondaryDocumentUserName": "ID de documento secundario",
  "clientNameOnDocument": "Nombre del cliente en el documento",
  "documentOne": "Documento 1",
  "documentTwo": "Documento 2",
  "secondaryDocumentName": "Nombre del documento secundario",
  "documentName": "Nombre del documento",
  "documentID": "ID del documento",
  "nameOnTheID": "Nombre en la ID",
  "creditFileSource": "Origen del archivo de crédito",
  "documentIssuingJurisdication": "Jurisdicción emisora del documento",
  "expiryDate": "Fecha de vencimiento del documento",
  "verifiedDate": "Fecha de verificación",
  "selectTheme": "Tema de la cartera",
  "selectProduct": "Seleccione el producto",
  "selectModel": "Seleccionar el modelo",
  "requireInvestorPolicyStatement": "Se requiere una declaración de política de inversión",
  "allowClientDeposits": "Permitir depósitos de clientes",
  "timeHorizon": "Horizonte temporal",
  "timeHorizonOptions": {
    "VERY_SHORT_TERM": "Menos de 1 año",
    "SHORT_TERM": "En 1 a 3 años",
    "MID_TERM": "En 4 a 6 años",
    "LONG_TERM": "En 7 o más años",
    "VERY_LONG_TERM": "A muy largo plazo"
  },
  "goalTimeHorizon": {
    "VERY_SHORT_TERM": "A muy corto plazo",
    "SHORT_TERM": "A corto plazo",
    "MID_TERM": "A mediano plazo",
    "LONG_TERM": "A largo plazo",
    "VERY_LONG_TERM": "A muy largo plazo"
  },
  "targetAmount": "Importe de meta",
  "sign": "Firme",
  "review": "Revisión",
  "done": "Hecho",
  "document": "Documento",
  "status": "Estado",
  "clientAgreements": "Cliente",
  "signed": "Firmado",
  "notSigned": "Sin firmar",
  "formPackage": "Paquete de formularios",
  "signingViewPreview": "Vista previa y firma",
  "signingPreviewDialogTitle": "Firmar documentos",
  "signingViewUrlMissing": "El enlace de firma aún no está disponible.",
  "formPackStates": {
    "DRAFT": "Borrador",
    "SENT": "Enviado",
    "COMPLETED": "Completado",
    "ARCHIVED": "Archivado",
    "DECLINED": "Rechazado",
    "OPTED_OUT": "Se ha excluido",
    "EXPIRED": "Vencido"
  },
  "reviewed": "Revisado",
  "notReviewed": "Sin revisar",
  "uploadSigned": "Suba el archivo firmado",
  "uploaded": "Cargado",
  "pending": "Pendiente",
  "upload": "Cargar",
  "signAndViewNext": "Firmar y ver siguiente",
  "reviewNext": "Revisar siguiente",
  "viewNext": "Ver siguiente",
  "continue": "Continuar",
  "update": "Actualizar",
  "downloadTemplate": "Descargar plantilla",
  "signAll": "Firme todo",
  "signAllAndContinue": "Firme todo y continúe",
  "signAndContinue": "Firme y continúe",
  "nothingToSign": "No hay ningún documento nuevo que firmar",
  "buttons": {
    "addGoal": "Añadir meta",
    "viewPDF": "Ver PDF"
  },
  "subAccountModal": {
    "editTitle": "Editar subcuenta",
    "addTitle": "Agregar una nueva subcuenta",
    "requireInvestorPolicyStatement": "Se requiere una declaración de política de inversión",
    "allowFractionalShares": "Permitir acciones fraccionadas",
    "liquidated": "Subcuenta liquidada",
    "liquidatedNoTooltip": "Para cambiar el estado de liquidación, inicie una transferencia de retiro total.",
    "liquidatedYesTooltip": "Al cambiar esto, los dividendos futuros NO se enviarán automáticamente al cliente."
  },
  "billingModal": {
    "title": "Editar facturación de subcuenta",
    "billingCycle": "Ciclo de facturación"
  },
  "accountDetails": {
    "transitions": {
      "active": "Transición a activo",
      "request": "Transición a lo solicitado",
      "fail": "Transición sin éxito",
      "cancel": "Transición a cancelar",
      "freeze": "Transición a congelar",
      "ready": "Transición a listo",
      "title": "Detalles de la cuenta"
    },
    "updateAccNo": "Actualice el número de cuenta",
    "viewStates": "Ver historial de estado",
    "asociateAccountToHousehold": "Cambiar a cuenta doméstica",
    "asociateAccountToNamedHousehold": "Cambiar a {{name}} cuenta doméstica",
    "dissociateAccountFromHousehold": "Desvincularse del hogar",
    "closeAccount": "Cerrar cuenta",
    "forceOpen": "Forzar la apertura de cuenta",
    "forceOpenSuccess": "La cuenta se enviará al administrador para su apertura una vez se hayan completado las aprobaciones pendientes."
  },
  "statements": {
    "custom": "Personalizado",
    "awaitingReview": "En espera de revisión",
    "yearToDate": "En lo que va del año",
    "reconciled": "Reconciliado",
    "allTime": "Todo el tiempo",
    "tax": "Impuesto",
    "any": "Cualquiera",
    "statements": "Declaraciones",
    "managementFees": "Tarifas de gestión",
    "failed": "Falló",
    "lastYear": "El año pasado",
    "byPeriod": "Por período",
    "fromDate": "Desde",
    "toDate": "A",
    "typeGroup": "Tipo",
    "state": "Estado",
    "accountType": "Tipo de cuenta",
    "thereAreNoStatements": "No hay declaraciones que mostrar"
  },
  "notes": {
    "types": {
      "ORGANIZATIONAL": "Organizacional",
      "PRIVATE": "Privado",
      "PUBLIC": "Público"
    },
    "subTitile": "Escriba una nota",
    "title": "Notas"
  },
  "taxLossHarvesting": "Recuperación de pérdidas fiscales",
  "documents": {
    "regeneratedToastMessage": "Se ha vuelto a generar el PDF.",
    "regenerate": "Regenerar PDF",
    "title": "Documentos",
    "addDocument": "Agregar documento",
    "searchByName": "Nombre del documento",
    "typeToSearch": "Escriba para buscar",
    "docType": "Tipo de documento",
    "docState": "Estado",
    "any": "Cualquiera",
    "name": "nombre",
    "associatedTo": "asociado a",
    "dateUpdated": "Fecha de actualización",
    "dateSigned": "Fecha de firma",
    "state": "estado",
    "PENDING": "Pendiente",
    "SIGNED": "Firmado",
    "SAVED": "Guardado",
    "signDigitally": "FIRMAR DIGITALMENTE",
    "uploadSignedDocument": "CARGAR DOCUMENTO FIRMADO",
    "downloadTemplate": "DESCARGAR PLANTILLA",
    "signConfirmationContent": "Usted va a firmar este documento como {{onBehalfOf}}.",
    "signConfimationTitile": "Firmar documento",
    "proceedDelete": "Sí, eliminar",
    "cancelDelete": "No, no borrar",
    "deleteConfirmationContent": "¿Está seguro de que desea eliminar este documento?",
    "deleteConfirmationTitle": "Eliminar documento",
    "downloadHtmlAsPdf": "Descargar/Imprimir",
    "uploadNewVersion": "Subir nueva versión",
    "htmlSection": "Documento HTML",
    "pdfSection": "Documento PDF",
    "allowClientToView": "Permitir al cliente ver el documento",
    "preventClientToView": "No permita que el cliente vea el documento",
    "sendToCustodian": "Habilitar el archivo para compartirlo con el administrador",
    "status": "Estado",
    "fileName": "archivo de documento",
    "download": "Descargar",
    "uploadDocument": "SUBIR DOCUMENTO",
    "deleteDocument": "Eliminar",
    "previewNotAvailable": "La vista previa no está disponible",
    "agreementNotAvailable": "El acuerdo no está disponible",
    "clientName": "Nombre del cliente",
    "type": "Tipo",
    "cantSignDigitallyPleaseUpload": "Este documento aún no se puede firmar digitalmente. Sube un archivo firmado en su lugar.",
    "documentHasBeenUploaded": "El documento se ha cargado"
  },
  "documentUpload": {
    "documentUpload": "Subir documentos",
    "documentName": "Nombre del documento",
    "documentType": "Tipo de documento",
    "associatedTo": "Asociado a",
    "uploadDocument": "Subir documento"
  },
  "droppableFileInput": {
    "dragFilesHere": "Arrastre y suelte un archivo aquí",
    "or": "o",
    "chooseAFile": "Elija un archivo",
    "chooseAnotherFile": "Elija otra opción",
    "fileSize": "Tamaño del archivo",
    "oneFileAtATime": "Un archivo a la vez"
  },
  "clientGroupSummary": {
    "establishedDate": "fecha de creación",
    "client": "cliente",
    "clients": "clientes",
    "inThisGroup": "en este grupo",
    "editClientGroupProfile": "editar perfil del grupo de clientes"
  },
  "clientGroupType": {
    "BUSINESS": "Empresa",
    "HOUSEHOLD": "Hogar"
  },
  "goalsSummary": {
    "header": "Metas",
    "addGoalBtn": "AGREGAR META",
    "ofTargetAmount": "del monto objetivo",
    "subAccountsLinked_one": "1 subcuenta vinculada",
    "subAccountsLinked_other": "{{count}} subcuentas vinculadas",
    "subAccountNeedsApproval_one": "1 subcuenta necesita aprobación",
    "subAccountNeedsApproval_other": "{{count}} las subcuentas necesitan aprobación",
    "goalStateLabel": "Objetivo del estado",
    "noGoals": "No tiene ningún objetivo",
    "goalState": {
      "ACTIVE": "Activo",
      "COMPLETED": "Completado",
      "ARCHIVED": "Cerrado"
    },
    "externalHoldingsLinked_one": "1 activo vinculado",
    "externalHoldingsLinked_other": "{{count}} Activos vinculados"
  },
  "accountsSummary": {
    "header": "Cuentas",
    "subAccountsLinked_one": "1 subcuenta vinculada",
    "subAccountsLinked_other": "{{count}} subcuentas vinculadas",
    "ofTotalAssets": "{{percentage}} del total de activos",
    "addAccountBtn": "AGREGAR CUENTA",
    "accountStateLabel": "Estado de la cuenta",
    "noAccounts": "No tiene ninguna cuenta",
    "externalHoldingsLinked_one": "1 activo vinculado",
    "externalHoldingsLinked_other": "{{count}} Activos vinculados",
    "repCodeLabel": "Código de representante",
    "repCodeNotAssigned": "No asignado"
  },
  "clientReportSummary": {
    "header": "Reportes de cliente",
    "noReports": "Actualmente no tiene reportes.",
    "noReportsFiltered": "No hay informes que coincidan con sus criterios de búsqueda"
  },
  "holdingsSummary": {
    "noHoldings": "No tiene ninguna participación"
  },
  "subAccountsSummary": {
    "header": "Carteras",
    "noSubAccounts": "No tiene ninguna cartera"
  },
  "accountsGroup": {
    "createAccountGroup": "Cree un grupo de cuentas",
    "groupName": "Nombre del grupo",
    "dragAccounts": "Arrastre las cuentas para crear un grupo",
    "newGroup": "+ Nuevo grupo",
    "ungroupedAccounts": "Cuentas sin agrupar",
    "searchUngroupedAccounts": "Buscar cuentas sin agrupar",
    "searchAccountGroupAccounts": "Buscar cuenta de grupo de cuentas",
    "addAccount": "Agregar cuenta",
    "createGroup": "Crear grupo",
    "removeFromGroup": "Eliminar del grupo",
    "deleteGroup": "Eliminar grupo",
    "viewGroup": "Ver",
    "seeMore": "Ver más",
    "view": {
      "list": "Vista de lista",
      "group": "Vista de grupo"
    },
    "totalAccount_one": "{{count}} cuenta",
    "totalAccount_other": "{{count}} cuentas",
    "tableHeaders": {
      "name": "Nombre del grupo de cuentas",
      "numberOfAccounts": "Número de cuentas",
      "organization": "Organización"
    },
    "columnHeaders": {
      "client": "Cliente",
      "accountName": "Nombre/Tipo de cuenta",
      "marketValue": "Valor de mercado"
    }
  },
  "assetsOverview": {
    "marketValue": "Valor de mercado",
    "totalAssets": "Total de activos",
    "totalSomeonesAssets": "Activos de {{name}}",
    "cashAvailable": "Efectivo disponible",
    "netContributions": "Contribuciones netas",
    "simpleRoR": "ROR simple",
    "timeWeightedRoR": "Tasa de rendimiento ponderada por el tiempo",
    "timeWeightedRoRAbbreviation": "TWRR",
    "moneyWeightedRoR": "Rendimiento ponderado del dinero",
    "moneyWeightedRoRAbbreviation": "MWRR",
    "cashOnHoldToWithdraw": "Efectivo en espera para retirar",
    "cashOnHoldToTrade": "Efectivo en espera para negociar",
    "newContributionsToday": "Nuevas contribuciones (hoy)",
    "contributionsToDate": "Contribuciones hasta la fecha",
    "allocationOfTotalInvestments": "Asignación de las inversiones totales",
    "holdings": "Activos",
    "missingExchangeRateMessage": "El tipo de cambio no está disponible",
    "emptyChart": "No hay historial disponible",
    "MAX": "MÁX",
    "YTD": "YTD",
    "1Y": "1A",
    "3M": "3M",
    "1M": "1M",
    "6M": "6M",
    "5Y": "5A",
    "customDateRange": "Fecha personalizada"
  },
  "performanceMetricsModal": {
    "title": "Métricas de rendimiento",
    "timeWeightedReturns": "Tasa de rendimiento ponderada por el tiempo (TWRR)",
    "moneyWeightedReturns": "Tasa de rendimiento ponderada por el dinero (MWRR)",
    "simpleRateOfReturn": "Tasa de rendimiento simple",
    "fxRate": {
      "title": "Tipo de cambio",
      "body": "{{from}} convertido a {{to}} al siguiente tipo de cambio: {{rate}}"
    }
  },
  "coporateAccounts": {
    "govFundOptions": {
      "ADDITIONAL_CESG": "CESG ADICIONAL",
      "BASIC_CESG": "CESG BÁSICO",
      "CLB": "CLB"
    },
    "newAccount": {
      "createAccount": "Crear cuenta corporativa",
      "selectGovernmentFund": "Seleccione fondos gubernamentales",
      "enableTLH": "Habilitar la compensación de pérdidas fiscales",
      "selectCorporateUser": "Seleccione usuario corporativo"
    },
    "relationshipOptions": {
      "PRIMARY_BENEFICIARY": "Beneficiario",
      "CONTINGENT_BENEFICIARY": "Beneficiario contingente",
      "AUTHORIZED_INDIVIDUAL": "Persona autorizada",
      "OTHER": "Otro",
      "TRUSTEE": "Fideicomisario",
      "POWER_OF_ATTORNEY": "Poder notarial",
      "JOINT": "Conjunto",
      "BENEFICIAL_OWNER": "Beneficiario efectivo",
      "SUCCESSOR": "Sucesor"
    }
  },
  "incompleteFields": "Campos incompletos",
  "padAgreement": "Acuerdo Pad",
  "frequency": {
    "BI_WEEKLY": "Quincenal",
    "DAILY": "Diario",
    "LAST_DAY_OF_THE_MONTH": "Último día del mes",
    "MONTHLY": "Mensual",
    "ONE_TIME": "Una sola vez",
    "SEMI_MONTHLY": "Dos veces al mes",
    "WEEKLY": "Semanal",
    "ANNUAL": "Anual",
    "QUARTERLY": "Trimestral",
    "SEMESTRAL": "Semestral"
  },
  "padAgreementTitle": "Acuerdo Pad",
  "canceled": "CANCELADO",
  "accountHolder": "Titular de la cuenta",
  "tradingProcessItems": {
    "INHERITED_FROM_PARENT": "Heredado de la organización principal",
    "NO_AUTOMATION": "Sin automatización",
    "PORTFOLIO_OPTIMIZER": "Optimizador de carteras",
    "REBALANCE_V1": "Reequilibrar v1",
    "REBALANCE_V2": "Reequilibrar v2"
  },
  "tradingProcess": "Proceso de operación",
  "overrideAccountsTaxRanks": "Anular rangos fiscales de cuentas",
  "accountTypes": "Tipos de cuentas",
  "overrideTaxRanks": "Anular rangos fiscales",
  "defaultTaxRanks": "Clasificaciones fiscales predeterminadas",
  "other": "Otro",
  "formTypes": {
    "FORM": "Formulario",
    "INVOICE": "Factura",
    "NOTES": "Notas",
    "OTHER": "Otro",
    "STATEMENT": "Declaración",
    "BANKING": "Banca",
    "LOGO": "Logotipo",
    "ID_VERIFICATION": "Verificación de ID"
  },
  "primaryDocument": "Documento 1: Verificación de dirección",
  "secondaryDocument": "Documento 2: Verificación de la fecha de nacimiento",
  "supportingDocuments": "Documentos de respaldo",
  "supportingDocument": "Documento de respaldo",
  "holdings": "Activos",
  "welcome": "Bienvenido",
  "affiliates": {
    "title": "Afiliados",
    "addNewAffiliate": "Agregar un afiliado nuevo"
  },
  "personalInformation": {
    "title": "Información personal"
  },
  "personOfInterest": {
    "title": "Persona de interés"
  },
  "employmentInformation": {
    "title": "Información laboral"
  },
  "nonIndividualInformation": {
    "title": "Información no personal"
  },
  "incomeAssetsAndDebts": {
    "title": "Ingresos, activos y deudas"
  },
  "scheduletransfers": {
    "title": "Programar transferencias"
  },
  "relationshipInformation": {
    "title": "Información de la relación"
  },
  "suitability": {
    "title": "Idoneidad"
  },
  "reviewBankAccountInformation": {
    "title": "Revisar la información de la cuenta bancaria"
  },
  "accountTable": {
    "account": "Cuenta",
    "name": "Nombre",
    "accountHolder": "Titular",
    "accountNumber": "Cuenta #",
    "program": "Calendario",
    "percentOfTotal": "% del total",
    "gainsAndLosses": "G/L No realizado",
    "currentValue": "Valor actual",
    "total": "Total"
  },
  "holdingTable": {
    "symbolName": "Símbolo: nombre",
    "quantity": "Cantidad",
    "bookCost": "Costo contable",
    "currentPrice": "Precio actual",
    "percentOfTotal": "% del total",
    "gainsAndLosses": "G/L No realizado",
    "1DayChange": "Cambio en 1 día",
    "currentValue": "Valor actual"
  },
  "editHousehold": {
    "edit": "Editar",
    "editHousehold": "Editar hogar",
    "archive": "Archivar",
    "name": "Nombre del hogar",
    "archiveHouseholdConfirmation": {
      "title": "¿Está seguro?",
      "bodyText": "Hay {{numOfMembers}} cliente/s en este hogar. Esto no eliminará la información del cliente, pero ya no estará asociado a este hogar."
    }
  },
  "editGoal": {
    "editGoal": "Editar meta",
    "edit": "Editar",
    "close": "Cerrar",
    "goalName": "Nombre de meta",
    "targetAmount": "Importe de meta",
    "cancel": "Cancelar",
    "closeGoal": "¿Está seguro?",
    "closeGoalText": "Antes de cerrar un objetivo, debe cerrar todas las carteras asociadas al mismo."
  },
  "goalInformation": {
    "title": "Información sobre meta"
  },
  "editSubAccount": {
    "close": "Cerrar",
    "activate": "Activar",
    "cancel": "Cancelar",
    "review": "Revisión",
    "closeSubAccount": "¿Está seguro?",
    "closeSubAccountText": "Antes de cerrar la cartera, asegúrese de que no haya fondos."
  },
  "editAccount": {
    "close": "Cerrar",
    "edit": "Editar",
    "cancel": "Cancelar",
    "closeAccount": "¿Está seguro?",
    "editAccount": "Editar cuenta",
    "closeAccountText": "Antes de cerrar una cuenta, debe cerrar todas las carteras asociadas a ella."
  },
  "editAccountGroup": {
    "title": "Editar grupo de cuentas",
    "edit": "Editar grupo",
    "delete": "Eliminar grupo",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "groupNameRequired": "Se requiere el nombre del grupo",
    "noAccountsInGroup": "Se requiere al menos una cuenta",
    "closeAccountGroup": "¿Está seguro?",
    "closeAccountGroupText": "¿Está seguro de que desea eliminar este grupo de cuentas?",
    "greyedAccountsCopy": "Las cuentas que aparecen en gris han sido cerradas o están congeladas"
  },
  "riskReturnLevels": {
    "VERY_LOW": "Riesgo muy bajo",
    "LOW": "Bajo riesgo",
    "MEDIUM": "Riesgo medio",
    "HIGH": "Alto riesgo",
    "VERY_HIGH": "Riesgo muy alto"
  },
  "portfolioBreakdown": "Desglose de la cartera",
  "currentPortfolio": "Cartera actual",
  "recommendedPortfolio": "Cartera recomendada",
  "idVerifications": {
    "secondaryDocumentType": "Tipo de información",
    "secondaryDocumentIssuingJurisdication": "Origen de la información",
    "secondaryDocumentExpiryDate": "Fecha de vencimiento",
    "secondaryDocumentID": "Número de referencia del documento",
    "secondaryDocumentUserName": "ID de documento secundario",
    "clientNameOnDocument": "Nombre del cliente en el documento",
    "documentOne": "Documento 1",
    "documentTwo": "Documento 2",
    "secondaryDocumentName": "Nombre del documento secundario",
    "documentName": "Nombre del documento",
    "documentID": "Número de referencia del documento",
    "nameOnTheID": "Nombre en la ID",
    "documentType": "Tipo de información",
    "creditFileSource": "Origen del archivo de crédito",
    "documentIssuingJurisdication": "Origen de la información",
    "expiryDate": "Fecha de vencimiento",
    "verifiedDate": "Fecha de verificación",
    "idVerificationMethods": {
      "CREDIT_CHECK": "Revisión de crédito",
      "DIGITAL_DOCUMENT_CHECK": "Revisión de documentos digitales",
      "DUAL_METHOD": "Método de doble proceso",
      "IN_PERSON_VALIDATION": "Validación presencial"
    },
    "address": "Dirección del documento",
    "secondaryDocumentDateOfBirth": "Documento de fecha de nacimiento",
    "secondaryDocumentVerifiedDate": "Fecha de verificación",
    "documentOneAddress": "Documento 1: Verificación de dirección",
    "documentTwoDateOfBirth": "Documento 2: Verificación de la fecha de nacimiento",
    "dateOfBirthValidation": "La fecha de nacimiento debe ser anterior a la fecha actual.",
    "underAgeValidation": "El cliente debe tener al menos {{MINUMUM_AGE}} años de edad.",
    "toggleDocumentA11y": "Alternar documento de identificación"
  },
  "saveAndContinue": "Guardar y continuar",
  "noAffiliates": "No hay afiliados asignados a esta cuenta",
  "bankAccount": {
    "youDontHaveAnyLinkedBankAccounts": "No tiene ninguna cuenta bancaria vinculada",
    "addAnotherbankAccount": "Agregar otra cuenta bancaria",
    "tdBank": "Banco TD",
    "bmoBank": "Banco BMO",
    "scotiaBank": "Scotiabank",
    "rbcBank": "Royal Bank of Canada",
    "nationalBankOfCanada": "National Bank of Canada",
    "cibc": "Canadian Imperial Bank of Commerce",
    "hsbcBank": "HSBC Bank Canada",
    "canadaWesternTrustBank": "Canadian Western Bank",
    "LauentianBank": "Laurentian Bank of Canada",
    "atbBank": "ATB Bank",
    "manulifeBank": "Manulife Bank of Canada",
    "eqLifeBank": "EQ Bank",
    "tangerineBank": "Tangerine Bank",
    "flinksBank": "Flinks",
    "coastCapitalBank": "Coast Capital",
    "desjardinsBank": "Desjardins Bank",
    "meridianBank": "Meridian Bank",
    "defaultBank": "Banco",
    "deleteBankAccountTitle": "Eliminar cuenta bancaria",
    "deleteBankAccountDesc": "¿Está seguro de que desea eliminar esta cuenta bancaria de su cuenta? Una vez eliminada, deberá volver a agregarla si cambia de opinión.",
    "confirm": "Confirmar",
    "bankAccountName": "Nombre de cuenta bancaria",
    "deleteAccount": "Eliminar cuenta",
    "save": "Guardar",
    "editBankAccount": "Editar cuenta bancaria"
  },
  "taxLotDetails": "Detalles del lote",
  "newTaxLotTitle": "Nuevo lote",
  "taxLotTable": {
    "openDate": "Fecha de apertura",
    "quantity": "Cantidad",
    "price": "Precio",
    "costBasis": "Base del costo",
    "marketValue": "Valor de mercado",
    "gainsLoss": "Ganancias/Pérdidas",
    "noTaxLots": "No se han añadido lotes a esta participación"
  },
  "newTaxLot": {
    "quantity": "Cantidad",
    "price": "Precio",
    "date": "Fecha de apertura"
  },
  "portfolioTargetHoldings": "Cartera de inversiones objetivo",
  "viewFundsFacts": "Ver datos del fondo",
  "total": "Total",
  "additionAccountInformation": "Información adicional de la cuenta",
  "holdingsProgressTitle": "Acciones de Packaging",
  "holdingsTable": {
    "symbol": "Símbolo",
    "securityName": "Nombre de seguridad",
    "quantity": "Cantidad",
    "bookCostNative": "Costo contable (nativo)",
    "bookCost": "Costo contable",
    "bookValue": "Valor contable",
    "localCost": "Costo local",
    "nativeCost": "Costo nativo",
    "localBookValue": "Valor contable local",
    "nativeBookValue": "Valor contable nativo",
    "custodianBookValue": "Valor contable del custodio",
    "currentPriceNative": "Precio actual (nativo)",
    "currentPrice": "Precio actual",
    "unrealizedGainLossCents": "G/L No realizado (centavos)",
    "unrealizedGainLossPercentage": "G/L No realizado (%)",
    "oneDayChangeCents": "Variación en 1 día (centavos)",
    "oneDayChangePercentage": "Variación en 1 día (%)",
    "percentOfTotal": "% del total",
    "currentValue": "Valor actual",
    "marketValueNative": "Valor de mercado (nativo)",
    "marketValue": "Valor de mercado",
    "type": "Tipo",
    "name": "Nombre",
    "fundSeries": "Serie de fondos"
  },
  "formLabels": {
    "physicalAddress": "Dirección física",
    "language": "Idioma"
  },
  "subAccountWithSuffix": "Subcuenta {{suffix}}",
  "expiryDateError": "La fecha de vencimiento del documento debe ser en el futuro",
  "optimizerProcessItems": {
    "PORTFOLIO_OPTIMIZER_V1": "Optimizador V1 (predeterminado)",
    "PORTFOLIO_OPTIMIZER_V2": "Optimizador V2"
  }
}
